import * as types from '../constants/ActionTypes';
import { INITIAL_STATE } from '../constants/InitialState';

export function UserReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_USER_CLAIMS:
      return {
        ...state,
        uid: payload.user_id,
        userClaims: payload,
      };

    case types.ADD_USER_DATA:
      return {
        ...state,
        userData: payload,
        savedEvents: payload && payload.savedEvents ? payload.savedEvents : [],
        favoriteChats: payload && payload.favoriteChats ? payload.favoriteChats : []
      };

    case types.DELETE_USER:
      return {
        ...state,
        uid: "",
        userData: {},
        userClaims: {},
      };

    case types.MAKE_CHAT_FAVORITE_START:
      return {
        ...state,
        saveLoadingOptions: {
          favoritesChatLoading: true,
          saveLoading: false,
          error: false,
          message: null
        }
      }

    case types.MAKE_CHAT_FAVORITE_SUCCESS:
      return {
        ...state,
        favoriteChats: payload,
        saveLoadingOptions: {
          favoritesChatLoading: false,
          saveLoading: false,
          error: false,
          messageType: 'success'
        },
      }

    case types.MAKE_CHAT_FAVORITE_FAIL:
      return {
        ...state,
        saveLoadingOptions: {
          favoritesChatLoading: false,
          saveLoading: false,
          error: payload,
          messageType: 'error'
        },
      }

    case types.SAVE_EVENT_START:
      return {
        ...state,
        saveLoadingOptions: {
          favoritesChatLoading: false,
          saveLoading: true,
          error: false,
          message: null
        },
      };

    case types.SAVE_EVENT_SUCCESS:
      return {
        ...state,
        savedEvents: payload,
        saveLoadingOptions: {
          favoritesChatLoading: false,
          saveLoading: false,
          error: false,
          messageType: 'success'
        },
      };

    case types.SAVE_EVENT_FAIL:
      return {
        ...state,
        saveLoadingOptions: {
          favoritesChatLoading: false,
          saveLoading: false,
          error: payload,
          messageType: 'error'
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js